<script lang="ts">
import { kMaxLength } from "buffer";

import { jsPDF } from "jspdf";
import { Transform } from "stream";
import { validate_each_argument } from "svelte/internal";
import { Character, characterStore } from "../character/character";
import type { Attribute } from "../groups/group";
import type { SpellList } from "../spells/spells";
import { translate } from "../translation";

let character:Character;

characterStore.subscribe(chara => character = chara)


const attributeNames = [
        "ID",
        "Name",
        "Rang",
        "Objekt",
        "Spezial",
        "Total"
]

const spellNames = [
        "ID",
        "Name",
        "Rang",
        "Total"
]

const charaNames = [
    "key1",
    "value1",
    "key2",
    "value2",
    "key3",
    "value3",
] 

const transformAttribute = (attr: Attribute) => {
        return {
            "ID": attr.id,
            "Name": attr.name,
            "Rang": "" + attr.level,
            "Objekt": "" + attr.object, 
            "Spezial": "" + attr.special,
            "Total": "" + attr.total,
        }
    }


const transformSpell = (attr: SpellList) => {
        return {
            "ID": attr.id,
            "Name": attr.name,
            "Rang": "" + attr.rank,
            "Punkte": "" + attr.points,
        }
    }



type MultiTable = {
    key1: string;
    value1: string;
    key2: string;
    value2: string;
    key3: string;
    value3: string;
}




function transformCharacter(character: Character){

    const lanes = [
        [
         "commonAttributes",
            "characterAttributes"
        ],
        [
           "resistance",
           "appearance",
        ],
        [
            "level",
            "defense" ,
        ]
    ].map(i => i.flatMap(n =>  Object.keys(character[n]).map(key => {
        return {
            key: translate(n + "." + key),
            value: "" + character[n][key]
        }
    })))



    let result = []
    lanes[0].forEach((val, index) => {
            result.push({
                key1: val.key,
                value1: val.value,
                key2: "",
                value2: "",
                key3: "",
                value3: "",
            })
    })
    

    lanes[1].forEach((val, index) => {

        if(result.length - 1 < index){
            result.push({
                    key1: "",
                    value1: "",
                    key2: val.key,
                    value2: val.value,
                    key3: "",
                    value3: "",
            })
        }else{
            console.log(index)
            console.log(val)
            console.log(result)
            result[index].key2 = val.key
            result[index].value2 = val.value
        }
    })

    lanes[2].forEach((val, index) => {

        if(result.length - 1 < index){
            result.push({
                    key1: "",
                    value1: "",
                    key2: "",
                    value2: "",
                    key3: val.key,
                    value3: val.value,
     
            })
        }else{
            result[index].key3 = val.key
            result[index].value3 = val.value
        }
        })



    return result

}


function print(){
    let doc = new jsPDF('p', 'pt', 'a4');



    const char = transformCharacter(character)

    const attributes = character.groups.flatMap(g => {
        return [
            transformAttribute(g.attribute),
        ].concat(g.attributes.map(transformAttribute))
    })

    const weapons = character.weapons.flatMap(g => {
        return [
            transformAttribute(g.group.attribute),
        ].concat(g.group.attributes.map(transformAttribute))
    })

    const spells = character.spellLists.map(transformSpell)



    doc.setFont("arial", "bold");
    doc.setFontSize(7);
    doc.table(20,20, char, charaNames, {})

    doc.addPage("Gruppen")
    doc.table(20,20, attributes, attributeNames, {})

    doc.addPage("Waffen")
    doc.table(20,20, weapons, attributeNames, {})
    
    doc.addPage("Sprüche")
    doc.table(20,20, spells, spellNames, {})


    doc.save('sample-file.pdf')
}
</script>

<a on:click="{print}">print</a>